import { useGrowthBook } from '@growthbook/growthbook-react';
import React, { useEffect } from 'react';

export const GrowthBookForcedFeatures: React.FC<{
  features: Map<string, unknown>;
}> = ({ features }) => {
  const gb = useGrowthBook();
  useEffect(() => {
    gb?.setForcedFeatures(features);
    return () => gb?.setForcedFeatures(new Map([]));
  }, [gb, features]);
  return null;
};
